import { useMutation } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { useJobRefetch } from '@hooks/job/refetch';
import { PublishInternalSchedulesReq } from './types';
import { DefaultApiResp } from '@root/globalTypes';
import { useErrors } from '@hooks/errors';

export const usePublishInternalSchedules = ({ callback }: { callback: () => void }) => {
  const { refetch } = useJobRefetch({ schedule: { type: 'internal', action: 'update' } });
  const handleErrors = useErrors({ allInToast: true });

  const { mutate, isPending } = useMutation({
    mutationFn: ({ ...data }: PublishInternalSchedulesReq): Promise<DefaultApiResp> => {
      return queryFetch({
        url: `schedules/publish`,
        data,
        opt: { method: 'POST' },
      });
    },
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data) => {
      if (!data) return;
      if (data.success) callback();
      else handleErrors(data.errors);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
